import { render, staticRenderFns } from "./matrix-upload-form.vue?vue&type=template&id=472fd387&scoped=true"
import script from "./matrix-upload-form.vue?vue&type=script&lang=ts"
export * from "./matrix-upload-form.vue?vue&type=script&lang=ts"
import style0 from "./matrix-upload-form.vue?vue&type=style&index=0&id=472fd387&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472fd387",
  null
  
)

export default component.exports